module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-square-logo-en-b4b57bf0d0f835dff6cc3c2f2156604b.svg";